var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4669 7.98172L17.0396 3.40902M2.89242 17.5562L7.4651 12.9835M12.4669 12.9835L17.0396 17.5562M2.89242 3.40902L7.4651 7.98171M6.42921 1.64062H13.5028C16.4328 1.64062 18.808 4.01584 18.808 6.94581V14.0194C18.808 16.9494 16.4328 19.3246 13.5028 19.3246H6.42921C3.49924 19.3246 1.12402 16.9494 1.12402 14.0194V6.94581C1.12402 4.01584 3.49924 1.64062 6.42921 1.64062ZM13.5028 10.4826C13.5028 12.4359 11.9193 14.0194 9.96599 14.0194C8.01268 14.0194 6.42921 12.4359 6.42921 10.4826C6.42921 8.52928 8.01268 6.94581 9.96599 6.94581C11.9193 6.94581 13.5028 8.52928 13.5028 10.4826Z",
    stroke: "#67A0C2",
    strokeWidth: 1.56035,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKub);
export default __webpack_public_path__ + "static/media/kub.b6410ff6626e0bf8dfc178386171b69e.svg";
export { ForwardRef as ReactComponent };